"use client"

interface Skill {
  name: string
  percentage: number
}

interface SkillTrackerProps {
  skills: Skill[]
}

export function SkillTracker({ skills }: SkillTrackerProps) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="text-base">📈</span>
        <h2 className="text-base font-bold text-slate-900">Skill Development</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
        {skills.map((skill) => (
          <div key={skill.name}>
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs font-medium text-slate-600">{skill.name}</span>
              <span className="text-xs font-semibold text-indigo-600">{skill.percentage}%</span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-1.5">
              <div
                className="bg-indigo-500 h-1.5 rounded-full transition-all duration-300"
                style={{ width: `${skill.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
